import { TactileCompanyTabs } from '@introcloud/api-client';
import { useTabConfiguration } from './useTab';

export function useCompanyEventDays():
  | TactileCompanyTabs['configuration']['event-days']
  | null {
  return useTabConfiguration('event-days') ?? null;
}
